<template>
    <b-v-form-btn-label-control
        :id="moreFiltersDropdownID"
        ref="control"
        :placeholder="placeholder"
        :class="['more-filters-dropdown', variant]"
        @show="handleDropdownShow"
        @hide="handleDropdownHide"
        @toggle="handleMoreFiltersDropdownToggle"
    >
        <b-button-group vertical class="buttons-wrapper">
            <slot :handle-dropdown-show="handleDropdownShow" :handle-dropdown-hide="handleDropdownHide"></slot>
        </b-button-group>
        <template v-slot:button-content>
            <div>
                <b-spinner small v-if="busy" variant="light"></b-spinner>
                <font-awesome-icon
                    v-else
                    :icon="icon"
                    :class="[variant, 'icon']"
                    size="lg"
                    :style="'height: 20px;'"
                ></font-awesome-icon>
            </div>
        </template>
    </b-v-form-btn-label-control>
</template>

<script>
    import uniqueId from 'lodash/uniqueId';
    import { BVFormBtnLabelControl } from 'bootstrap-vue/src/components/form-btn-label-control/bv-form-btn-label-control';

    export default {
        name: 'MoreFiltersDropdown',
        props: {
            busy: {
                type: Boolean,
                default: false,
            },
            variant: {
                type: String,
                default: 'primary',
            },
            icon: {
                type: [Object, Array, String],
                default: () => ['fas', 'ellipsis-vertical'],
            },
            placeholder: {
                type: String,
                default: '',
            },
        },
        components: {
            BVFormBtnLabelControl,
        },
        data() {
            return {
                moreFiltersDropdownID: uniqueId('more-filters-dropdown-'),
                innerDropdownShown: false,
            };
        },
        methods: {
            handleDropdownShow(e) {
                if (e.componentId !== this.moreFiltersDropdownID) {
                    this.innerDropdownShown = true;
                }
            },
            handleDropdownHide(e) {
                if (e.componentId !== this.moreFiltersDropdownID) {
                    this.innerDropdownShown = false;
                }

                if (this.innerDropdownShown) {
                    e.preventDefault();
                }
            },
            handleMoreFiltersDropdownToggle(e) {
                if (this.innerDropdownShown) {
                    this.innerDropdownShown = false;
                }

                this.$nextTick(() => {
                    this.$refs.control.hide();
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    $cell-round-border: 50%;
    $selected-button-color: #08c;
    $primary-color: #0d47a1;
    $max-viewport-height: 60vh;
    $button-height: 28px;

    .primary {
        color: #fff !important;
        background-color: $primary-color !important;
        border-color: $primary-color !important;

        &:hover {
            background-color: #0a377e !important;
            border-color: #093272 !important;
        }

        > :deep(label) {
            display: none !important;
        }
    }

    .more-filters-dropdown {
        &.outline-primary {
            background-color: #fff !important;
            border-color: $primary-color !important;

            .icon {
                color: $primary-color !important;
            }

            &:hover {
                background-color: $primary-color !important;
                border-color: $primary-color !important;

                .icon {
                    color: #fff !important;
                }
            }

            > :deep(label) {
                display: none !important;
            }
        }
    }

    .buttons-wrapper {
        width: max-content;
    }

    .more-filters-dropdown :deep(.b-dropdown .dropdown-toggle) {
        border-radius: 0.25rem !important;
    }

    .more-filters-dropdown .buttons-wrapper > :deep(*) {
        margin-bottom: 0.25rem;
        border-radius: 0.25rem !important;
    }
    .icon {
        height: 21px !important;
    }
    @include media-breakpoint-down(md) {
        .icon {
            height: 24px !important;
        }
    }
</style>
